import React from "react"
import PropTypes from "prop-types"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faLink } from "@fortawesome/free-solid-svg-icons"
import Button from "../../button"

const ExternalLinkCell = ({ value }) =>
  value && value.length > 1 ? (
    <Button href={value} size="small" variant="secondary" outlined target="_blank" rel="noopener noreferrer">
      <FontAwesomeIcon icon={faLink} />
    </Button>
  ) : null

ExternalLinkCell.propTypes = {
  value: PropTypes.string
}

ExternalLinkCell.defaultProps = {
  value: ""
}

export default ExternalLinkCell
